﻿import { useAuthStore } from '../../store/authStore';
import { Calendar, Clock } from 'lucide-react';
import { useHorarioAtual } from '../../api/hooks/useHorarios';
import '../../components/ui/datatable.css';



export function MinhaGradePage() {
  const user = useAuthStore((s) => s.user);
  const { horariosHoje } = useHorarioAtual(user?.id);
  const aulas = horariosHoje.filter((h: any) => h.tipo === 'AULA');

  return (
    <div className="admin-page">
      <div className="page-header"><div><h1>Minha Grade</h1><p>Horários de aula</p></div></div>

      {aulas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>
          <Calendar size={40} style={{ margin: '0 auto 16px', color: '#d1d5db' }} />
          <p>Nenhuma aula hoje</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 12 }}>
          {aulas.map((h: any) => (
            <div key={h.id} className="kpi-card hover-lift" style={{ gap: 12, flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ width: 48, height: 48, borderRadius: 10, background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563eb', fontWeight: 800, fontSize: '1.1rem' }}>
                {h.numeroAula}ª
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{h.materia?.nome || 'Matéria'}</div>
                <div style={{ display: 'flex', gap: 12, fontSize: '0.78rem', color: '#6b7280', marginTop: 2 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 3 }}><Clock size={12} /> {h.horaInicio}–{h.horaFim}</span>
                  <span>{h.turma?.nome || ''}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
